import {useDispatch, useSelector} from "react-redux";
import {rxReorderRules, rxShowRuleEditor, selectAllRules} from "../../../../slices/rulesSlice";
import {useTranslation} from "react-i18next";
import {selectAllCategories} from "../../../../slices/categoriesSlice";
import {useState} from "react";
import {findRule} from "../../../../util/util";
import {selectAllTags} from "../../../../slices/tagsSlice";
import {updatePositions} from "../../../../api/ApiTransactionRules";
import useNetwork from "../../../../util/useNetwork";

const useSettingsRules = () => {
  const dispatch = useDispatch();

  const {t} = useTranslation("settings_rules");

  const {handleNetworkError} = useNetwork();

  const transactionRules = useSelector(selectAllRules);
  const transactionCategories = useSelector(selectAllCategories);
  const transactionTags = useSelector(selectAllTags);

  const [testValue, setTestValue] = useState("");

  const showRuleEditor = (mode, rule) => dispatch(rxShowRuleEditor({mode, rule}));

  const updateTestValue = e => setTestValue(e.target.value);

  const sortRules = event => {
    const {active, over} = event;

    if (active.id !== over.id) {
      const activeRule = transactionRules.find(a => a.id === active.id);
      const overRule = transactionRules.find(a => a.id === over.id);

      const newRules = [];

      if (overRule.position > activeRule.position) {
        for (let transactionRule of transactionRules) {
          if (transactionRule === activeRule) {
            continue;
          }

          newRules.push(transactionRule);

          if (transactionRule === overRule) {
            newRules.push(activeRule);
          }
        }
      } else {
        for (let transactionRule of transactionRules) {
          if (transactionRule === overRule) {
            newRules.push(activeRule);
          }

          if (transactionRule!== activeRule) {
            newRules.push(transactionRule);
          }
        }
      }

      dispatch(rxReorderRules(newRules));

      updatePositions(newRules.map(a => a.id)).catch(handleNetworkError);
    }
  };

  return {
    t,
    transactionRules,
    transactionCategories,
    transactionTags,
    showRuleEditor,
    testValue,
    updateTestValue,
    testMatchingRule: findRule(transactionRules, testValue),
    sortRules
  };
};

export default useSettingsRules;
